import { MouseEventHandler } from "react";

const BraidSVG = ({ handleClick }: { handleClick: MouseEventHandler }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 110 315"
    className="max-h-screen max-w-1/4 flex-1 braid"
    onClick={handleClick}
  >
    <path d="M70 15 55 0l-5 5 15 15Z" className="nine-b" />
    <path d="M70 25 55 10l-5 5 15 15Z" className="two-t" />
    <path d="M70 35 55 20l-5 5 15 15Z" className="four-t" />
    <path d="M70 45 55 30l-5 5 15 15Z" className="six-t" />
    <path d="M0 5v10l10 10 5-5Z" className="one-t" />
    <path d="M0 15v10l10 10 5-5Z" className="three-t" />
    <path d="M0 25v10l10 10 5-5Z" className="five-t" />
    <path d="M0 35v10l10 10 5-5Z" className="seven-t" />
    <path d="M0 45v10l10 10 5-5Z" className="fifteen-t" />
    <path d="M0 55v10l10 10 5-5Z" className="thirteen-t" />
    <path d="M0 65v10l10 10 5-5Z" className="eleven-t" />
    <path d="M0 75v10l10 10 5-5Z" className="nine-t" />
    <path d="M0 85v10l10 10 5-5Z" className="two-b" />
    <path d="M0 95v10l10 10 5-5z" className="four-b" />
    <path d="M0 105v10l10 10 5-5z" className="six-b" />
    <path d="M0 115v10l10 10 5-5z" className="eight-b" />
    <path d="M0 125v10l10 10 5-5z" className="fourteen-b" />
    <path d="M0 135v10l10 10 5-5z" className="twelve-b" />
    <path d="M0 145v10l10 10 5-5z" className="ten-b" />
    <path d="M0 155v10l10 10 5-5z" className="one-b" />
    <path d="M0 165v10l10 10 5-5z" className="three-b" />
    <path d="M0 175v10l10 10 5-5z" className="five-b" />
    <path d="M0 185v10l10 10 5-5z" className="seven-b" />
    <path d="M0 195v10l10 10 5-5z" className="fifteen-b" />
    <path d="M0 205v10l10 10 5-5z" className="thirteen-b" />
    <path d="M0 215v10l10 10 5-5z" className="eleven-b" />
    <path d="M0 225v10l10 10 5-5z" className="nine-b" />
    <path d="M0 235v10l10 10 5-5z" className="two-t" />
    <path d="M0 245v10l10 10 5-5z" className="four-t" />
    <path d="M0 255v10l10 10 5-5z" className="six-t" />
    <path d="M0 265v10l10 10 5-5z" className="eight-t" />
    <path d="M0 275v10l10 10 5-5z" className="fourteen-t" />
    <path d="M0 285v10l10 10 5-5z" className="twelve-t" />
    <path d="M0 295v10l10 10 5-5z" className="ten-t" />
    <path d="M110 5v10l-10 10-5-5Z" className="one-b" />
    <path d="M110 15v10l-10 10-5-5Z" className="three-b" />
    <path d="M110 25v10l-10 10-5-5Z" className="five-b" />
    <path d="M110 35v10l-10 10-5-5Z" className="seven-b" />
    <path d="M110 45v10l-10 10-5-5Z" className="fifteen-b" />
    <path d="M110 55v10l-10 10-5-5Z" className="thirteen-b" />
    <path d="M110 65v10l-10 10-5-5Z" className="eleven-b" />
    <path d="M110 75v10l-10 10-5-5Z" className="nine-b" />
    <path d="M110 85v10l-10 10-5-5z" className="two-t" />
    <path d="M110 95v10l-10 10-5-5z" className="four-t" />
    <path d="M110 105v10l-10 10-5-5z" className="six-t" />
    <path d="M110 115v10l-10 10-5-5z" className="eight-t" />
    <path d="M110 125v10l-10 10-5-5z" className="fourteen-t" />
    <path d="M110 135v10l-10 10-5-5z" className="twelve-t" />
    <path d="M110 145v10l-10 10-5-5z" className="ten-t" />
    <path d="M110 155v10l-10 10-5-5z" className="one-t" />
    <path d="M110 165v10l-10 10-5-5z" className="three-t" />
    <path d="M110 175v10l-10 10-5-5z" className="five-t" />
    <path d="M110 185v10l-10 10-5-5z" className="seven-t" />
    <path d="M110 195v10l-10 10-5-5z" className="fifteen-t" />
    <path d="M110 205v10l-10 10-5-5z" className="thirteen-t" />
    <path d="M110 215v10l-10 10-5-5z" className="eleven-t" />
    <path d="M110 225v10l-10 10-5-5z" className="nine-t" />
    <path d="M110 235v10l-10 10-5-5z" className="two-b" />
    <path d="M110 245v10l-10 10-5-5z" className="four-b" />
    <path d="M110 255v10l-10 10-5-5z" className="six-b" />
    <path d="M110 265v10l-10 10-5-5z" className="eight-b" />
    <path d="M110 275v10l-10 10-5-5z" className="fourteen-b" />
    <path d="M110 285v10l-10 10-5-5z" className="twelve-b" />
    <path d="M110 295v10l-10 10-5-5z" className="ten-b" />
    <path d="M10 15 25 0l5 5-15 15Z" className="seven-t" />
    <path d="m10 25 15-15 5 5-15 15Z" className="fifteen-t" />
    <path d="m10 35 15-15 5 5-15 15Z" className="thirteen-t" />
    <path d="m10 45 15-15 5 5-15 15Z" className="eleven-t" />
    <path d="m10 55 15-15 5 5-15 15Z" className="nine-t" />
    <path d="m10 65 15-15 5 5-15 15Z" className="two-b" />
    <path d="m10 75 15-15 5 5-15 15Z" className="four-b" />
    <path d="m10 85 15-15 5 5-15 15Z" className="six-b" />
    <path d="m10 95 15-15 5 5-15 15z" className="eight-b" />
    <path d="m10 105 15-15 5 5-15 15z" className="fourteen-b" />
    <path d="m10 115 15-15 5 5-15 15z" className="twelve-b" />
    <path d="m10 125 15-15 5 5-15 15z" className="ten-b" />
    <path d="m10 135 15-15 5 5-15 15z" className="one-b" />
    <path d="m10 145 15-15 5 5-15 15z" className="three-b" />
    <path d="m10 155 15-15 5 5-15 15z" className="five-b" />
    <path d="m10 165 15-15 5 5-15 15z" className="seven-b" />
    <path d="m10 175 15-15 5 5-15 15z" className="fifteen-b" />
    <path d="m10 185 15-15 5 5-15 15z" className="thirteen-b" />
    <path d="m10 195 15-15 5 5-15 15z" className="eleven-b" />
    <path d="m10 205 15-15 5 5-15 15z" className="nine-b" />
    <path d="m10 215 15-15 5 5-15 15z" className="two-t" />
    <path d="m10 225 15-15 5 5-15 15z" className="four-t" />
    <path d="m10 235 15-15 5 5-15 15z" className="six-t" />
    <path d="m10 245 15-15 5 5-15 15z" className="eight-t" />
    <path d="m10 255 15-15 5 5-15 15z" className="fourteen-t" />
    <path d="m10 265 15-15 5 5-15 15z" className="twelve-t" />
    <path d="m10 275 15-15 5 5-15 15z" className="ten-t" />
    <path d="m10 285 15-15 5 5-15 15z" className="one-t" />
    <path d="m10 295 15-15 5 5-15 15z" className="three-t" />
    <path d="m10 305 15-15 5 5-15 15z" className="five-t" />
    <path d="M100 15 85 0l-5 5 15 15Z" className="seven-b" />
    <path d="M100 25 85 10l-5 5 15 15Z" className="fifteen-b" />
    <path d="M100 35 85 20l-5 5 15 15Z" className="thirteen-b" />
    <path d="M100 45 85 30l-5 5 15 15Z" className="eleven-b" />
    <path d="M100 55 85 40l-5 5 15 15Z" className="nine-b" />
    <path d="M100 65 85 50l-5 5 15 15Z" className="two-t" />
    <path d="M100 75 85 60l-5 5 15 15Z" className="four-t" />
    <path d="M100 85 85 70l-5 5 15 15Z" className="six-t" />
    <path d="M100 95 85 80l-5 5 15 15Z" className="eight-t" />
    <path d="M100 105 85 90l-5 5 15 15Z" className="fourteen-t" />
    <path d="m100 115-15-15-5 5 15 15z" className="twelve-t" />
    <path d="m100 125-15-15-5 5 15 15z" className="ten-t" />
    <path d="m100 135-15-15-5 5 15 15z" className="one-t" />
    <path d="m100 145-15-15-5 5 15 15z" className="three-t" />
    <path d="m100 155-15-15-5 5 15 15z" className="five-t" />
    <path d="m100 165-15-15-5 5 15 15z" className="seven-t" />
    <path d="m100 175-15-15-5 5 15 15z" className="fifteen-t" />
    <path d="m100 185-15-15-5 5 15 15z" className="thirteen-t" />
    <path d="m100 195-15-15-5 5 15 15z" className="eleven-t" />
    <path d="m100 205-15-15-5 5 15 15z" className="nine-t" />
    <path d="m100 215-15-15-5 5 15 15z" className="two-b" />
    <path d="m100 225-15-15-5 5 15 15z" className="four-b" />
    <path d="m100 235-15-15-5 5 15 15z" className="six-b" />
    <path d="m100 245-15-15-5 5 15 15z" className="eight-b" />
    <path d="m100 255-15-15-5 5 15 15z" className="fourteen-b" />
    <path d="m100 265-15-15-5 5 15 15z" className="twelve-b" />
    <path d="m100 275-15-15-5 5 15 15z" className="ten-b" />
    <path d="m100 285-15-15-5 5 15 15z" className="one-b" />
    <path d="m100 295-15-15-5 5 15 15z" className="three-b" />
    <path d="m100 305-15-15-5 5 15 15z" className="five-b" />
    <path d="m65 90 15-15 5 5-15 15Z" className="seven-b" />
    <path d="m65 100 15-15 5 5-15 15z" className="fifteen-b" />
    <path d="m65 110 15-15 5 5-15 15z" className="thirteen-b" />
    <path d="m65 120 15-15 5 5-15 15z" className="eleven-b" />
    <path d="m65 130 15-15 5 5-15 15z" className="nine-b" />
    <path d="m65 140 15-15 5 5-15 15z" className="two-t" />
    <path d="m65 150 15-15 5 5-15 15z" className="four-t" />
    <path d="m65 160 15-15 5 5-15 15z" className="six-t" />
    <path d="m65 170 15-15 5 5-15 15z" className="eight-t" />
    <path d="m65 180 15-15 5 5-15 15z" className="fourteen-t" />
    <path d="m65 190 15-15 5 5-15 15z" className="twelve-t" />
    <path d="m65 200 15-15 5 5-15 15z" className="ten-t" />
    <path d="m65 210 15-15 5 5-15 15z" className="one-t" />
    <path d="m65 220 15-15 5 5-15 15z" className="three-t" />
    <path d="m65 230 15-15 5 5-15 15z" className="five-t" />
    <path d="m65 240 15-15 5 5-15 15z" className="seven-t" />
    <path d="m65 250 15-15 5 5-15 15z" className="fifteen-t" />
    <path d="m65 260 15-15 5 5-15 15z" className="thirteen-t" />
    <path d="m65 270 15-15 5 5-15 15z" className="eleven-t" />
    <path d="m65 280 15-15 5 5-15 15z" className="nine-t" />
    <path d="m65 290 15-15 5 5-15 15z" className="two-b" />
    <path d="m65 300 15-15 5 5-15 15z" className="four-b" />
    <path d="m65 310 15-15 5 5-15 15z" className="six-b" />
    <path d="M65 20 80 5l5 5-15 15Z" className="eight-b" />
    <path d="m65 30 15-15 5 5-15 15Z" className="fourteen-b" />
    <path d="m65 40 15-15 5 5-15 15Z" className="twelve-b" />
    <path d="m65 50 15-15 5 5-15 15Z" className="ten-b" />
    <path d="m65 60 15-15 5 5-15 15Z" className="one-b" />
    <path d="m65 70 15-15 5 5-15 15Z" className="three-b" />
    <path d="m65 80 15-15 5 5-15 15Z" className="five-b" />
    <path d="M45 90 30 75l-5 5 15 15Z" className="seven-t" />
    <path d="M45 100 30 85l-5 5 15 15Z" className="fifteen-t" />
    <path d="M45 110 30 95l-5 5 15 15z" className="thirteen-t" />
    <path d="m45 120-15-15-5 5 15 15z" className="eleven-t" />
    <path d="m45 130-15-15-5 5 15 15z" className="nine-t" />
    <path d="m45 140-15-15-5 5 15 15z" className="two-b" />
    <path d="m45 150-15-15-5 5 15 15z" className="four-b" />
    <path d="m45 160-15-15-5 5 15 15z" className="six-b" />
    <path d="m45 170-15-15-5 5 15 15z" className="eight-b" />
    <path d="m45 180-15-15-5 5 15 15z" className="fourteen-b" />
    <path d="m45 190-15-15-5 5 15 15z" className="twelve-b" />
    <path d="m45 200-15-15-5 5 15 15z" className="ten-b" />
    <path d="m45 210-15-15-5 5 15 15z" className="one-b" />
    <path d="m45 220-15-15-5 5 15 15z" className="three-b" />
    <path d="m45 230-15-15-5 5 15 15z" className="five-b" />
    <path d="m45 240-15-15-5 5 15 15z" className="seven-b" />
    <path d="m45 250-15-15-5 5 15 15z" className="fifteen-b" />
    <path d="m45 260-15-15-5 5 15 15z" className="thirteen-b" />
    <path d="m45 270-15-15-5 5 15 15z" className="eleven-b" />
    <path d="m45 280-15-15-5 5 15 15z" className="nine-b" />
    <path d="m45 290-15-15-5 5 15 15z" className="two-t" />
    <path d="m45 300-15-15-5 5 15 15z" className="four-t" />
    <path d="m45 310-15-15-5 5 15 15z" className="six-t" />
    <path d="M45 20 30 5l-5 5 15 15Z" className="eight-t" />
    <path d="M45 30 30 15l-5 5 15 15Z" className="fourteen-t" />
    <path d="M45 40 30 25l-5 5 15 15Z" className="twelve-t" />
    <path d="M45 50 30 35l-5 5 15 15Z" className="ten-t" />
    <path d="M45 60 30 45l-5 5 15 15Z" className="one-t" />
    <path d="M45 70 30 55l-5 5 15 15Z" className="three-t" />
    <path d="M45 80 30 65l-5 5 15 15Z" className="five-t" />
    <path d="m70 125-15-15-5 5 15 15z" className="seven-t" />
    <path d="m70 135-15-15-5 5 15 15z" className="fifteen-t" />
    <path d="m70 145-15-15-5 5 15 15z" className="thirteen-t" />
    <path d="m70 155-15-15-5 5 15 15z" className="eleven-t" />
    <path d="m70 165-15-15-5 5 15 15z" className="nine-t" />
    <path d="m70 175-15-15-5 5 15 15z" className="two-b" />
    <path d="m70 185-15-15-5 5 15 15z" className="four-b" />
    <path d="m70 195-15-15-5 5 15 15z" className="six-b" />
    <path d="m70 205-15-15-5 5 15 15z" className="eight-b" />
    <path d="m70 215-15-15-5 5 15 15z" className="fourteen-b" />
    <path d="m70 225-15-15-5 5 15 15z" className="twelve-b" />
    <path d="m70 235-15-15-5 5 15 15z" className="ten-b" />
    <path d="m70 245-15-15-5 5 15 15z" className="one-b" />
    <path d="m70 255-15-15-5 5 15 15z" className="three-b" />
    <path d="m70 265-15-15-5 5 15 15z" className="five-b" />
    <path d="m70 275-15-15-5 5 15 15z" className="seven-b" />
    <path d="m70 285-15-15-5 5 15 15z" className="fifteen-b" />
    <path d="m70 295-15-15-5 5 15 15z" className="thirteen-b" />
    <path d="m70 305-15-15-5 5 15 15z" className="eleven-b" />
    <path d="M70 55 55 40l-5 5 15 15Z" className="eight-t" />
    <path d="M70 65 55 50l-5 5 15 15Z" className="fourteen-t" />
    <path d="M70 75 55 60l-5 5 15 15Z" className="twelve-t" />
    <path d="M70 85 55 70l-5 5 15 15Z" className="ten-t" />
    <path d="M70 95 55 80l-5 5 15 15Z" className="one-t" />
    <path d="M70 105 55 90l-5 5 15 15Z" className="three-t" />
    <path d="m70 115-15-15-5 5 15 15z" className="five-t" />
    <path d="M40 15 50 5l5 5-10 10Z" className="nine-t" />
    <path d="m40 25 10-10 5 5-10 10Z" className="two-b" />
    <path d="m40 35 10-10 5 5-10 10Z" className="four-b" />
    <path d="m40 45 10-10 5 5-10 10Z" className="six-b" />
    <path d="m40 55 10-10 5 5-10 10Z" className="eight-b" />
    <path d="m40 65 10-10 5 5-10 10Z" className="fourteen-b" />
    <path d="m40 75 10-10 5 5-10 10Z" className="twelve-b" />
    <path d="m40 85 10-10 5 5-10 10Z" className="ten-b" />
    <path d="m40 95 10-10 5 5-10 10z" className="one-b" />
    <path d="m40 105 10-10 5 5-10 10z" className="three-b" />
    <path d="m40 115 10-10 5 5-10 10z" className="five-b" />
    <path d="m40 125 10-10 5 5-10 10z" className="seven-b" />
    <path d="m40 135 10-10 5 5-10 10z" className="fifteen-b" />
    <path d="m40 145 10-10 5 5-10 10z" className="thirteen-b" />
    <path d="m40 155 10-10 5 5-10 10z" className="eleven-b" />
    <path d="m40 165 10-10 5 5-10 10z" className="nine-b" />
    <path d="m40 175 10-10 5 5-10 10z" className="two-t" />
    <path d="m40 185 10-10 5 5-10 10z" className="four-t" />
    <path d="m40 195 10-10 5 5-10 10z" className="six-t" />
    <path d="m40 205 10-10 5 5-10 10z" className="eight-t" />
    <path d="m40 215 10-10 5 5-10 10z" className="fourteen-t" />
    <path d="m40 225 10-10 5 5-10 10z" className="twelve-t" />
    <path d="m40 235 10-10 5 5-10 10z" className="ten-t" />
    <path d="m40 245 10-10 5 5-10 10z" className="one-t" />
    <path d="m40 255 10-10 5 5-10 10z" className="three-t" />
    <path d="m40 265 10-10 5 5-10 10z" className="five-t" />
    <path d="m40 275 10-10 5 5-10 10z" className="seven-t" />
    <path d="m40 285 10-10 5 5-10 10z" className="fifteen-t" />
    <path d="m40 295 10-10 5 5-10 10z" className="thirteen-t" />
    <path d="m40 305 10-10 5 5-10 10z" className="eleven-t" />
  </svg>
);

export default BraidSVG;
